import React from 'react';

function Time({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M11.75 6.5V12.75L15.5 16.75" />
      <circle cx="12" cy="12" r="10" />
    </svg>
  );
}

export default Time;
